import { render, staticRenderFns } from "./connected-call-list.vue?vue&type=template&id=04c51e96&"
import script from "./connected-call-list.vue?vue&type=script&lang=js&"
export * from "./connected-call-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports